import MainHeading from "@/components/MainHeading"
import $ from 'jquery'

export default {
  name: "Project",
  components: {
    MainHeading
  },
  props: {
    title: ''
  },
  data() {
    return {
      subtitle: 'Project',
      images: [],
      imageRoute: './../../assets/'
    }
  },
  mounted() {
    let picWidth = $(window).width() < 768 ? '150vw' : '50vw'

    Array.from($('.picGrid')).forEach(pic => {
      let ratio = $(pic).width() / $(pic).height()
      console.log(ratio)
      $(pic).css({
        minHeight: `calc(${picWidth} / ${ratio})`
      })
    })
  }
}
